let baseUrl = process.env.VUE_APP_API_BASE_URL

// 英文 spec
export const newEnSpec = {
  verifyUrl: baseUrl + 'api/newSpec/verify',
  addVerifyListUrl: baseUrl + 'api/newSpec/addVerifyList',
  itemCodeListUrl: baseUrl + 'api/newSpec/getItemCodeList',
  pageListUrl: baseUrl + 'api/newSpec/getPageList',
  infoUrl: baseUrl + 'api/newSpec/info',
  infoByItemCodeUrl: baseUrl + 'api/newSpec/infoByItemCode',
  auditedListUrl: baseUrl + 'api/newSpecAudited/auditedList',
  auditedLatestInfoUrl: baseUrl + 'api/newSpecAudited/latestInfo',
  addUrl: baseUrl + 'api/newSpec/add',
  updateUrl: baseUrl + 'api/newSpec/update',
  updateRowUrl: baseUrl + 'api/newSpec/updateRow',
  updateVersionUrl: baseUrl + 'api/newSpec/updateVersion',
  saveOrUpdateUrl: baseUrl + 'api/newSpec/saveOrUpdate',
  deleteUrl: baseUrl + 'api/newSpec/delete',
  itemCodeExistUrl: baseUrl + 'api/newSpec/itemCodeExists',
  getAuditedItemCodeListUrl: baseUrl + 'api/newSpecAudited/getAuditedItemCodeList',
}
// 中文 spec
export const newCnSpec = {
  itemCodeListUrl: baseUrl + 'api/newCnSpec/getItemCodeList',
  addVerifyListUrl: baseUrl + 'api/newCnSpec/addVerifyList',
  addUrl: baseUrl + 'api/newCnSpec/add',
  updateUrl: baseUrl + 'api/newCnSpec/update',
  updateRowUrl: baseUrl + 'api/newCnSpec/updateRow',
  updateVersionUrl: baseUrl + 'api/newCnSpec/updateVersion',
  saveOrUpdateUrl: baseUrl + 'api/newCnSpec/saveOrUpdate',
  pageListUrl: baseUrl + 'api/newCnSpec/getPageList',
  infoUrl: baseUrl + 'api/newCnSpec/info',
  infoByItemCodeUrl: baseUrl + 'api/newCnSpec/infoByItemCode',
  auditedListUrl: baseUrl + 'api/newCnSpecAudited/auditedList',
  auditedLatestInfoUrl: baseUrl + 'api/newCnSpecAudited/latestInfo',
  verifyUrl: baseUrl + 'api/newCnSpec/verify',
  deleteUrl: baseUrl + 'api/newCnSpec/delete',
  itemCodeExistUrl: baseUrl + 'api/newCnSpec/itemCodeExists',
  getAuditedItemCodeListUrl: baseUrl + 'api/newCnSpecAudited/getAuditedItemCodeList',
}
// 英文 sds
export const newEnSds = {
  pageListUrl: baseUrl + 'api/newSds/getPageList',
  addUrl: baseUrl + 'api/newSds/add',
  updateUrl: baseUrl + 'api/newSds/update',
  updateRowUrl: baseUrl + 'api/newSds/updateRow',
  saveOrUpdateUrl: baseUrl + 'api/newSds/saveOrUpdate',
  infoUrl: baseUrl + 'api/newSds/info',
  deleteUrl: baseUrl + 'api/newSds/delete',
  verifyUrl: baseUrl + 'api/newSds/verify',
  addVerifyListUrl: baseUrl + 'api/newSds/addVerifyList',
  copyUrl: baseUrl + 'api/newSds/copy',
  matchUrl: baseUrl + 'api/newSds/match',
  itemCodeList: baseUrl + 'api/newSds/getItemCodeList',
  infoByItemCodeUrl: baseUrl + 'api/newSds/infoByItemCode',
  auditedListUrl: baseUrl + 'api/newSdsAudited/auditedList',
  auditedLatestInfoUrl: baseUrl + 'api/newSdsAudited/latestInfo',
}
// 中文 sds
export const newCnSds = {
  itemCodeListUrl: baseUrl + 'api/newCnSds/getItemCodeList',
  pageListUrl: baseUrl + 'api/newCnSds/getPageList',
  saveOrUpdateUrl: baseUrl + 'api/newCnSds/saveOrUpdate',
  auditedLatestInfoUrl: baseUrl + 'api/newCnSdsAudited/latestInfo',
  addUrl: baseUrl + 'api/newCnSds/add',
  updateUrl: baseUrl + 'api/newCnSds/update',
  updateRowUrl: baseUrl + 'api/newCnSds/updateRow',
  infoUrl: baseUrl + 'api/newCnSds/info',
  infoByItemCodeUrl: baseUrl + 'api/newSds/infoByItemCode',
  auditedListUrl: baseUrl + 'api/newCnSdsAudited/auditedList',
  verifyUrl: baseUrl + 'api/newCnSds/verify',
  addVerifyListUrl: baseUrl + 'api/newCnSds/addVerifyList',
  deleteUrl: baseUrl + 'api/newCnSds/delete',
}

// 英文 coa
export const newEnCoa = {
  pageListUrl: baseUrl + 'api/newCoa/getPageList',
  infoUrl: baseUrl + 'api/newCoa/info',
  infoByLotUrl: baseUrl + 'api/newCoa/infoByLot',
  addUrl: baseUrl + 'api/newCoa/add',
  updateUrl: baseUrl + 'api/newCoa/update',
  saveOrUpdateUrl: baseUrl + 'api/newCoa/saveOrUpdate',
  deleteUrl: baseUrl + 'api/newCoa/delete',
  verifyUrl: baseUrl + 'api/newCoa/verify',
  suggestionsList: baseUrl + 'api/newCoa/getSuggestions',
  updateRowUrl: baseUrl + 'api/newCoa/updateRow',
  excelImportUrl: 'https://spec.dracoherbs.com/coa/coa_excel_import',
  auditedListUrl: baseUrl + 'api/newCoaAudited/auditedList',
  auditedLatestInfoUrl: baseUrl + 'api/newCoaAudited/latestInfo',
}

// 中文 coa
export const newCnCoa = {
  pageListUrl: baseUrl + 'api/newCnCoa/getPageList',
  infoUrl: baseUrl + 'api/newCnCoa/info',
  infoByLotUrl: baseUrl + 'api/newCnCoa/infoByLot',
  addUrl: baseUrl + 'api/newCnCoa/add',
  updateUrl: baseUrl + 'api/newCnCoa/update',
  saveOrUpdateUrl: baseUrl + 'api/newCnCoa/saveOrUpdate',
  deleteUrl: baseUrl + 'api/newCnCoa/delete',
  verifyUrl: baseUrl + 'api/newCnCoa/verify',
  suggestionsList: baseUrl + 'api/newCoa/getSuggestions',
  updateRowUrl: baseUrl + 'api/newCnCoa/updateRow',
  excelImportUrl: 'https://spec.dracoherbs.com/coa/coa_excel_import',
  auditedListUrl: baseUrl + 'api/newCnCoaAudited/auditedList',
  auditedLatestInfoUrl: baseUrl + 'api/newCnCoaAudited/latestInfo',
}

export const userManager = {
  userList: baseUrl + 'api/sysUser/getPageList',
  userAdd: baseUrl + 'api/sysUser/add',
  userUpdate: baseUrl + 'api/sysUser/update',
  userRemove: baseUrl + 'api/sysUser/delete',
  resetUserPassword: baseUrl + 'api/sysUser/resetPassword'
}

// email test
export const emailTest = {
  emailTriggerList: baseUrl + 'emailtrigger/email_triggers_list',  
  testEmailUrl: baseUrl + 'emailtrigger/email_triggers_test',
  testAddEmailUrl: baseUrl + 'emailtrigger/save_email_triggers_test'
} 

// newSubstanceName
export const newSubstanceName = {
  pageListUrl: baseUrl + 'api/newSubstanceName/getPageList',
  allListUrl: baseUrl + 'api/newSubstanceName/getAllList',
  infoUrl: baseUrl + 'api/newSubstanceName/info',
  addUrl: baseUrl + 'api/newSubstanceName/add',
  updateUrl: baseUrl + 'api/newSubstanceName/update',
  deleteUrl: baseUrl + 'api/newSubstanceName/delete',
}